var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInputTypePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1303 9.1469C20.2899 7.92683 20.2899 6.07317 19.1303 4.8531C17.1745 2.79533 13.8155 0 10 0C6.18448 0 2.82549 2.79533 0.869705 4.8531C-0.289902 6.07317 -0.289902 7.92683 0.869706 9.1469C2.82549 11.2047 6.18448 14 10 14C13.8155 14 17.1745 11.2047 19.1303 9.1469ZM10 10C11.6569 10 13 8.65685 13 7C13 5.34315 11.6569 4 10 4C8.34315 4 7 5.34315 7 7C7 8.65685 8.34315 10 10 10Z",
    fill: "#16191D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInputTypePassword);
export default __webpack_public_path__ + "static/media/icon-input_type_password.dc1b322e8fbbe969985e081f8ce59bf9.svg";
export { ForwardRef as ReactComponent };